import { render, staticRenderFns } from "./noteList-add-or-update.vue?vue&type=template&id=11440434&scoped=true"
import script from "./noteList-add-or-update.vue?vue&type=script&lang=js"
export * from "./noteList-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./noteList-add-or-update.vue?vue&type=style&index=0&id=11440434&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11440434",
  null
  
)

export default component.exports